import { useSelector } from "react-redux";
import { selectGlobalState } from "../../state-management/selectors";
import * as Icons from "../../assets/SVGs/index";

export default function apiChart() {
  const { departmentsData, newsData, articlesData, projectsData } =
    useSelector(selectGlobalState);

  const lengthData = [
    {
      name: "دپارتمان",
      active: departmentsData?.filter((item: any) => item.is_active).length,
      deactive: departmentsData?.filter((item: any) => !item.is_active).length,
      icon: Icons.DepartmentIcon,
    },
    {
      name: "اخبار",
      active: newsData?.filter((item: any) => item.is_active).length,
      deactive: newsData?.filter((item: any) => !item.is_active).length,
      icon: Icons.NewsIcon,
    },
    {
      name: "مقالات",
      active: articlesData?.filter((item: any) => item.is_active).length,
      deactive: articlesData?.filter((item: any) => !item.is_active).length,
      icon: Icons.ArticleIcon,
    },
    {
      name: "پروژه ها",
      active: projectsData?.filter((item: any) => item.is_active).length,
      deactive: projectsData?.filter((item: any) => !item.is_active).length,
      icon: Icons.ProjectIcon,
    },
  ];
  return lengthData;
}
